/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import pinia from '@/stores';
import router from '@/router';
import sentry from '@/plugins/sentry';
import { mediapipePlugin } from '@/plugins/mediapipe';
import vuetify from './vuetify';

export function registerPlugins(app) {
  app
    .use(vuetify)
    .use(router)
    .use(pinia)
    .use(sentry)
    .use(mediapipePlugin());
}
